const envOverrides = {};
if (typeof import.meta !== "undefined" && import.meta.env) {
  const prefix = "VITE_FF_";
  for (const [key, value] of Object.entries(import.meta.env)) {
    if (key.startsWith(prefix)) {
      const flagName = key.slice(prefix.length);
      envOverrides[flagName] = value === "true" || value === "1";
    }
  }
}

export const FEATURE_FLAGS = {
  FRIEND_PROFILE_AS_MODAL: true,
  ...envOverrides,
};

export function isFeatureEnabled(flagName) {
  return FEATURE_FLAGS[flagName] ?? false;
}
